import React, { useEffect, useState } from 'react';

export default function RiskGauge({ score }) {
  const [animated, setAnimated] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setAnimated(score), 100);
    return () => clearTimeout(t);
  }, [score]);

  const color = score >= 70 ? 'var(--risk-high)' : score >= 40 ? 'var(--risk-medium)' : 'var(--risk-low)';
  const label = score >= 70 ? 'High Risk' : score >= 40 ? 'Medium Risk' : 'Low Risk';

  const size = 96;
  const r = 36;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;
  // Arc from 135deg to 405deg (270deg sweep)
  const sweepDeg = 270;
  const startAngle = 135;
  const endAngle = startAngle + sweepDeg;
  const pct = animated / 100;
  const arc = circumference * (sweepDeg / 360);
  const dashOffset = arc - pct * arc;

  function polar(cx, cy, r, angleDeg) {
    const rad = (angleDeg - 90) * Math.PI / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  function describeArc(cx, cy, r, startDeg, endDeg) {
    const start = polar(cx, cy, r, startDeg);
    const end = polar(cx, cy, r, endDeg);
    const largeArc = endDeg - startDeg > 180 ? 1 : 0;
    return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`;
  }

  const trackPath = describeArc(cx, cy, r, startAngle, endAngle);

  return (
    <div style={{ textAlign: 'center', flexShrink: 0 }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ overflow: 'visible' }}>
        {/* Track */}
        <path d={trackPath} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="5" strokeLinecap="round" />
        {/* Arc */}
        <path
          d={trackPath}
          fill="none"
          stroke={color}
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={`${arc} ${circumference}`}
          strokeDashoffset={dashOffset}
          style={{ transition: 'stroke-dashoffset 0.9s cubic-bezier(0.34,1.56,0.64,1)', filter: `drop-shadow(0 0 6px ${color})` }}
        />
        {/* Score */}
        <text x={cx} y={cy - 2} textAnchor="middle" fill="var(--text-primary)"
          style={{ fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-body)' }}>
          {score}
        </text>
        <text x={cx} y={cy + 13} textAnchor="middle" fill="var(--text-tertiary)"
          style={{ fontSize: 8, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase', fontFamily: 'var(--font-body)' }}>
          / 100
        </text>
      </svg>
      <div style={{ fontSize: 11, fontWeight: 600, color, letterSpacing: 0.5, textTransform: 'uppercase', marginTop: -4 }}>
        {label}
      </div>
    </div>
  );
}
